import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-683c2bf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-xl-stretch mb-xl-12" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "svg-icon svg-icon-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Tìm kiếm ")
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Thêm mới ")
const _hoisted_9 = { class: "card-body pt-3" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table table-row-dashed table-row-gray-300 table-striped border align-middle gs-0 gy-4" }
const _hoisted_12 = { class: "fw-bolder text-dark fs-5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "w-75px text-center" }, "STT", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Ảnh", -1))
const _hoisted_15 = { class: "min-w-150px text-start" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Tiêu đề")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px text-end" }, "Danh mục", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px text-end" }, "Trạng thái", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px text-end" }, "Ngày đăng", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px pe-5 text-end" }, "Hành động", -1))
const _hoisted_21 = { style: {"display":"none"} }
const _hoisted_22 = { class: "w-75px text-center" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_28 = { class: "text-muted" }
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 0,
  class: "text-end"
}
const _hoisted_31 = { class: "text-muted fw-bold text-end" }
const _hoisted_32 = { class: "d-flex justify-content-end" }
const _hoisted_33 = { class: "text-muted fw-bold text-end" }
const _hoisted_34 = { class: "text-end pe-5" }
const _hoisted_35 = { class: "svg-icon svg-icon-3" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "svg-icon svg-icon-3" }
const _hoisted_38 = { class: "card-footer pt-3" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-2" }
const _hoisted_41 = ["value", "selected"]
const _hoisted_42 = { class: "col-10 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, { class: "d-flex align-items-center position-relative my-1" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "data-kt-customer-table-filter": "search",
              class: "form-control border-gray-400 w-250px",
              placeholder: "Tiêu đề bài viết...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.s_name) = $event)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.s_name]
            ]),
            _createVNode(_component_el_form_item, { class: "mb-0 ms-2 border-gray-400" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.s_categories,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.s_categories) = $event)),
                  multiple: "",
                  filterable: "",
                  "allow-create": "",
                  "default-first-option": "",
                  placeholder: "Danh mục tin"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCategories, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _createVNode(_component_el_option, {
                          label: item.name,
                          value: item._id
                        }, null, 8, ["label", "value"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child_, index_) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index_ }, [
                            (item.children.length > 1)
                              ? (_openBlock(), _createBlock(_component_el_option, {
                                  key: 0,
                                  label: '- ' + child_.name,
                                  value: child_._id
                                }, null, 8, ["label", "value"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary ms-1 me-3 ms-5",
              "data-kt-menu-trigger": "click",
              "data-kt-menu-placement": "bottom-end",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
            }, [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen004.svg" }),
                _hoisted_5
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/contents/news/add",
          class: "btn btn-primary",
          "data-kt-menu-trigger": "click",
          "data-kt-menu-placement": "bottom-end",
          "data-kt-menu-flip": "top-end"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" }),
              _hoisted_8
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", _hoisted_11, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_12, [
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("th", _hoisted_15, [
                _createElementVNode("a", {
                  class: "text-primary",
                  href: "javascript:void(0)",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClickSort('name')))
                }, [
                  _withDirectives(_createElementVNode("i", {
                    class: _normalizeClass(["fa text-primary", {
                      'fa-sort-amount-down': _ctx.params.order === 'desc',
                      'fa-sort-amount-up': _ctx.params.order === 'asc',
                    }])
                  }, null, 2), [
                    [_vShow, _ctx.params.order_by === 'name']
                  ]),
                  _hoisted_16
                ])
              ]),
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _hoisted_20
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("tr", _hoisted_21, [
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.domain_FE +
                '/' +
                (item.category ? item.category.slug : '') +
                '/' +
                item?.slug), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_22, _toDisplayString(index + 1 + (_ctx.page - 1) * _ctx.limit), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("img", {
                          src: _ctx.renderImageUrl(item.thumbnail, 'small'),
                          alt: ""
                        }, null, 8, _hoisted_25)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createTextVNode(_toDisplayString(item.name) + " ", 1),
                        _createElementVNode("p", _hoisted_28, [
                          _createElementVNode("a", {
                            target: "_blank",
                            href: 
                            _ctx.domain_FE +
                            '/' +
                            (item.category ? item.category.slug : '') +
                            '/' +
                            item?.slug
                          
                          }, _toDisplayString(item.slug), 9, _hoisted_29)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    (item.category)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(item.category.name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_el_switch, {
                        modelValue: item.status,
                        "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                        "active-value": "active",
                        "inactive-value": "inactive"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_33, _toDisplayString(item.created_at), 1),
                  _createElementVNode("td", _hoisted_34, [
                    _createVNode(_component_router_link, {
                      to: 'news/edit/' + item._id,
                      class: "btn btn-icon btn-bg-light btn-color-primary btn-sm me-1 ms-1"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_35, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: ($event: any) => (_ctx.onClickDelete(item._id)),
                      class: "btn btn-icon border btn-color-danger btn-sm"
                    }, [
                      _createElementVNode("span", _hoisted_37, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                      ])
                    ], 8, _hoisted_36)
                  ])
                ])
              ], 64))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("select", {
            class: "form-select",
            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeLimit($event)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitData, (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: item,
                selected: item === _ctx.params.limit
              }, _toDisplayString(item), 9, _hoisted_41))
            }), 128))
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_v_pagination, {
            modelValue: _ctx.params.page,
            "onUpdate:modelValue": [
              _cache[6] || (_cache[6] = ($event: any) => ((_ctx.params.page) = $event)),
              _ctx.onChangePage
            ],
            pages: _ctx.totalPages,
            "range-size": 1,
            "active-color": "#eee"
          }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
        ])
      ])
    ])
  ]))
}